<div>

  <bi-header></bi-header>
  <div
    *ngIf="idleHeartbeat.warningVisible()"
    class="idle-session-warning"
    role="alertdialog"
    aria-live="assertive"
    (click)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
  >
    <p>{{ idleHeartbeat.warningMessage() }}</p>
    <button type="button" class="idle-session-warning__continue" (click)="onIdleContinue($event)">
      Continue session
    </button>
  </div>
  <div class="biRepBlock" #scrollableDiv [class.stickyLeft]="isScrolled" (scroll)="onScroll()">



    <router-outlet></router-outlet>

    <!-- Alternative lightweight spinner -->
    <!-- <bi-spinner-alternative></bi-spinner-alternative> -->
    <!--loading the when the time of autherization starts here-->

    <!--<div *ngIf="currentUser" class="p-dialog-mask p-component-overlay p-component-overlay-enter"
        style="z-index:99999;background-color: rgb(0 0 0 / 75%);transition-duration: 0.2s;animation: inherit;">
        <div class="pLoader"></div>
    </div>-->


    <!-- <div *ngIf="_commonMethods.isEmpty(currentUser)" class="loader-mask">       
      <p-progress-spinner strokeWidth="3" animationDuration="1s" ariaLabel="loading" />
    </div> -->

    <!--ends loading the when the time of autherization here-->
    <!-- Toaster -->
    <p-toast id="generic_toast" [hideTransitionOptions]="'450ms ease-in'" [key]="'genericToastKey'"
      position="top-center" [baseZIndex]="9999"></p-toast>



  </div>








  
<!-- Take a Tour Start -->
<div *ngIf="tour.isOpen()">
	<div class="tour-highlight" [ngStyle]="tour.styles().high"></div>
  
	<div id="tourBox" [ngStyle]="tour.styles().box">
	  <div class="tour-header">
		<span id="stepCount">Step {{tour.currentIndex() + 1}} of {{tour.steps().length}} </span>
		<button (click)="tour.close()" class="btn-close">&times;</button>
	  </div>
  
	  <div class="tour-content">
		<div class="tour-media" *ngIf="tour.steps()[tour.currentIndex()]?.i">
		  <img [src]="tour.steps()[tour.currentIndex()].i" class="tour-img">
		</div>
  
		<h4 id="tourTitle">{{tour.steps()[tour.currentIndex()]?.t}}</h4>
		<p id="tourDesc">{{tour.steps()[tour.currentIndex()]?.d}}</p>
	  </div>
  
	  <div class="tour-footer">
		<button (click)="tour.back()" 
				class="btn-back cursor-pointer" 
				[style.visibility]="tour.currentIndex() === 0 ? 'hidden' : 'visible'">
		  Back
		</button>
		<button (click)="tour.next()" class="btn-next">
		  {{tour.currentIndex() === tour.steps().length - 1 ? 'Finish' : 'Next'}}
		</button>
	  </div>
	</div>
  </div>
  <!-- End Take a Tour -->

  <!-- Main modern spinner - appended to body by component -->
  <bi-spinner></bi-spinner>